<div class="placeholder-container">
  <mat-icon [icon]="'search-x'" [iconSize]="40" />
  <p>{{ 'NoContentPlaceholderText' | transloco }}</p>
</div>
